import styled from "styled-components";
import { ThemePalette } from "../../../theme";

export const UserListOutline = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  margin-right: 1.5rem;
  opacity: 0.6;
  font-weight: bold;
  cursor: not-allowed;
  > div {
    border: 0.02rem solid ${() => ThemePalette.colorPrimaryLighter};
  }
`;
export const UserListWrapper = styled.div`
  overflow-y: auto;
  height: 85%;
`;
export const Label = styled.label`
  display: flex;
  flex-direction: row;
  color: ${ThemePalette.colorPrimaryDark};
  padding: 1rem;
  text-decoration: none;
  li {
    display: inline-block;
    margin: 0 1rem;
    padding-right: 6.75rem;
  }
  .user {
    padding-right: 5.5rem;
  }
`;

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 2rem;
  width: 100%;
  padding: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  button {
    padding: 0.5rem 5rem;
    width: 8rem;
    align-items: center;
    text-align: center;
  }
`;

export const InviteButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  button {
    padding: 0rem 2rem;
    width: 8rem;
    align-items: center;
    text-align: center;
  }
`;

export const InviteUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  height: 80%;
  width: 60%;
  background-color: ${ThemePalette.colorWhite};
  border-radius: 1.5rem;
  box-shadow: 0 0 1rem 0 ${ThemePalette.colorGrayLight};
`;

export const InviteUserList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: hidden;
`;

export const Border = styled.hr`
  border-top: 1px solid ${ThemePalette.colorGrayLight};
`;

export const UserList = styled.div`
  margin-top: 1rem;
  margin-bottom: 3rem;
  overflow-y: scroll;

  > div {
    border: 0.02rem solid ${() => ThemePalette.colorPrimaryLighter};
    background-color: ${ThemePalette.colorGrayLight};
    color: ${ThemePalette.colorPrimaryDark};
  }
`;
export const UserEditListOutline = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
  font-weight: bold;
  > div {
    border: 0.02rem solid ${() => ThemePalette.colorPrimaryLighter};
  }
`;
export const FlexBlock = styled.div`
  width: auto;
  padding: 0.2rem 4rem 0.2rem 0;
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-items: flex-start;

  > span {
    font-weight: lighter;
    width: 10rem;
  }
`;
export const Close = styled.div`
  color: ${ThemePalette.colorWhite};
  background-color: ${ThemePalette.colorError};
  border-radius: 2rem;
  border: 0.1rem solid ${ThemePalette.colorError};
  cursor: pointer;
  position: absolute;
  padding: 0rem 0.3rem;
  font-size: 0.8rem;
  top: 0.6rem;
  right: 1rem;
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 90%;
  height: 3rem;
  border-radius: 0.5rem;
  border: 0.1rem solid ${ThemePalette.colorPrimary};
`;
export const SearchIcon = styled.img`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 0.5rem;
  color: ${ThemePalette.colorGrayLight};
  transform: translateY(-50%);
  width: 2rem;
  height: 1.5rem;
`;

// moved from DeliverableListComponent.styles.tsx
export const StyledProjectListScreen = styled.div`
  display: flex;
  position: fixed;
  font-family: "Open Sans", sans-serif;
`;

export const StyledWrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  padding: 0.5rem 2rem 4rem 2rem;

  > div {
    border: 0.02rem solid ${() => ThemePalette.colorPrimaryLighter};
  }

  > div:hover {
    cursor: pointer;
    box-shadow: ${() => ThemePalette.colorPrimaryLighter} 0rem 0.625rem 1rem
      0.625rem;
    -webkit-transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  row-gap: 2rem;
  justify-content: flex-start;
  justify-items: start;
  align-items: center;
`;
export const EmptyProjectPlaceholderContainer = styled.div`
  height: 100%;
  font-size: 2rem;
  display: flex;
  color: ${() => `${ThemePalette.colorGrayDark}50`};
  align-items: center;
  justify-content: center;
  border: none !important;
  box-shadow: none !important;
  transition: none !important;
  border: none !important;
  margin: auto;
  width: max-content;
  :hover {
    box-shadow: none !important;
    transition: none !important;
  }
`;
export const LoaderWrapperComponent = styled.div`
  justify-content: center;
  height: 50%;
  display: flex;
  align-items: center;
  border: none !important;
  box-shadow: none !important;
  transition: none !important;
  :hover {
    box-shadow: none !important;
    transition: none !important;
  }
`;
export const Scroll = styled.div`
  padding: 0.2rem 0 0.2rem 1rem;
  display: flex;
  border-left: 0.2rem solid ${() => ThemePalette.colorGrayLight};
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  justify-content: flex-start;
  position: relative;
  width: 100%;

  &::-webkit-scrollbar {
    height: 0.3rem;
    cursor: pointer;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${ThemePalette.colorPrimary};
    border-radius: 1rem;
    width: 0.5rem;
    height: 0.5rem;
  }
`;

export const EmptyProjectPlaceholderContent = styled.p``;
